import { gql } from '@apollo/client';

export const GET_LIBRO_ID = gql`
  {
    getLibroId @client
  }
`;

export const GET_LIBRO = gql`
  query getLibro($id: ID!) {
    getLibro(id: $id) {
      _id
      titulo
      autor
      resumen
      estado
      caratula
      datos
    }
  }
`;

export const GET_LIBROS = gql`
  query getLibros($paginate: getLibrosPaginate!) {
    getLibros(paginate: $paginate) {
      libros {
        node {
          _id
          titulo
          autor
          resumen
          estado
          caratula
          datos
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const SEARCH_LIBROS = gql`
  query searchLibros($paginate: searchLibrosPaginate!) {
    searchLibros(paginate: $paginate) {
      libros {
        node {
          _id
          titulo
          autor
          resumen
          estado
          caratula
          datos
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const ADD_LIBRO = gql`
  mutation createLibro($input: CreateLibroInput!) {
    createLibro(input: $input) {
      _id
      titulo
      autor
      resumen
      estado
      caratula
      datos
      code
      success
      message
    }
  }
`;

export const UPDATE_LIBRO = gql`
  mutation updateLibro($input: UpdateLibroInput) {
    updateLibro(input: $input) {
      _id
      titulo
      autor
      resumen
      estado
      caratula
      datos
      code
      success
      message
    }
  }
`;

export const REMOVE_LIBRO = gql`
  mutation removeLibro($input: DeleteLibroInput!) {
    removeLibro(input: $input) {
      code
      success
      message
    }
  }
`;
